// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import PreviewDocument from './data'

export default function PreviewDocumentFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/PreviewDocument">
      <PreviewDocument {...props}>
        {children}
      </PreviewDocument>
    </Flow>
  )
}
